import {
  type AppointmentFilterActions,
  type CalenderAppointmentsSearchFilters,
} from "@/features/calendar/calendarFilter/appointmentFilterReducer";
import {
  selectEmail,
  selectTeam,
} from "@/features/calendar/calendarFilter/appointmentFilterSelector";
import { useCalendarSettings, useMyTeams, useProfile } from "@repo/api";
import isEmpty from "lodash/isEmpty";
import { useEffect, useRef } from "react";

export const useSetDefaultCoWorkerAndTeam = (
  filters: CalenderAppointmentsSearchFilters,
  actions: AppointmentFilterActions,
  isLoadingCalendarSettings?: boolean
) => {
  const { data: profile } = useProfile();
  const { data: myTeams } = useMyTeams();
  const { data: calendarSettings } = useCalendarSettings();
  const calendarSettingsRef = useRef(calendarSettings);
  calendarSettingsRef.current = calendarSettings;

  const tableView = filters.tableView;
  const selectedTeam = selectTeam(filters);
  const selectedEmail = selectEmail(filters);

  useEffect(() => {
    if (isLoadingCalendarSettings) {
      return;
    }

    if (tableView === "TEAM") {
      const defaultTeam = myTeams?.find((team) => team.default) ?? myTeams?.[0];

      if (!selectedTeam && defaultTeam && !selectedEmail) {
        const deselectedMemberIds =
          calendarSettingsRef.current?.deselectedMembersByTeam?.[
            defaultTeam.teamId
          ] ?? [];
        actions.setTeamCalendar({
          selection: {
            kind: "team",
            teamId: defaultTeam.teamId,
            assignedToTeam: false,
            deselectedMemberIds,
          },
          emailId: [],
          saveSettings: false,
        });
      }
    } else {
      if (isEmpty(selectedEmail) && profile?.mail) {
        actions.setAgendaCalendar({ emailId: [profile.mail] });
        actions.setOverviewCalendar({ emailId: [profile.mail] });
      }
    }
  }, [
    tableView,
    selectedTeam,
    selectedEmail,
    actions,
    profile?.mail,
    myTeams,
    isLoadingCalendarSettings,
  ]);
};
